var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useAppState } from '../context/AppStateContext';
import '../../styles/ProductLabel.css';
export default function ProductLabel(props) {
    var _a, _b, _c, _d;
    var language = useLanguage().language;
    var _e = useAppState(), hoveredProductName = _e.hoveredProductName, isPopupOpen = _e.isPopupOpen;
    var _f = useState(true), isShown = _f[0], setIsShown = _f[1];
    var _g = useState({ x: 0, y: 0 }), position = _g[0], setPosition = _g[1];
    var _h = useState(''), title = _h[0], setTitle = _h[1];
    var popupRef = useRef(null);
    var _j = useState(false), isLeft = _j[0], setIsLeft = _j[1];
    // Paramètres géométriques
    var diagLength = 60; // longueur du segment diagonal
    var diagAngle = 30; // angle du segment diagonal
    var horizLength = 70; // ↓ réduit (était 90)
    var diagRad = (Math.PI / 180) * diagAngle;
    // Arrondis en pixels entiers : le segment diagonal est positionné via
    // `transform: rotate()` (arrondi par le compositeur GPU) et le segment
    // horizontal via `left`/`top` classiques (arrondi par le moteur de mise en
    // page) — deux chemins d'arrondi différents. Avec des valeurs fractionnaires
    // (cos/sin de 30°), leur point de jonction pouvait tomber sur des pixels
    // légèrement différents selon le côté, créant un micro-décalage visible.
    var offX = Math.round(Math.cos(diagRad) * diagLength);
    var offY = Math.round(Math.sin(diagRad) * diagLength);
    useEffect(function () {
        var handleMouseMove = function (event) {
            setPosition({ x: event.clientX, y: event.clientY });
        };
        window.addEventListener('mousemove', handleMouseMove);
        return function () { return window.removeEventListener('mousemove', handleMouseMove); };
    }, []);
    useEffect(function () {
        setIsShown(props.IsVisible);
    }, [props.IsVisible]);
    useEffect(function () {
        function loadLabelTitle() {
            return __awaiter(this, void 0, void 0, function () {
                var data, titleFromFile, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, import("../../Ressources/".concat(hoveredProductName, "/").concat(props.SubsidiaryForTexts, "_textes_liens_").concat(hoveredProductName, "_").concat(language, ".json"))];
                        case 1:
                            data = _a.sent();
                            titleFromFile = data.texts.title;
                            setTitle(titleFromFile.join('\n'));
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error('Erreur de chargement du label :', error_1);
                            setTitle('');
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        if (hoveredProductName) {
            loadLabelTitle();
        }
    }, [hoveredProductName, props.SubsidiaryForTexts, language]);
    // Orientation auto
    useEffect(function () {
        var _a;
        var popupW = ((_a = popupRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 300;
        var needRight = offX + horizLength + popupW + 20;
        var spaceRight = window.innerWidth - position.x;
        setIsLeft(spaceRight < needRight);
    }, [position.x, offX, horizLength, title, isShown]);
    var canDisplay = isShown &&
        position.y < window.innerHeight - 20 &&
        position.x < window.innerWidth - 20 &&
        position.y > 100 &&
        !isPopupOpen;
    // Styles calculés
    // Miroir (axe vertical) de l'angle "droite" (-diagAngle) : 180 - (-diagAngle) =
    // 180 + diagAngle, PAS 180 - diagAngle (qui pointe vers le bas-gauche au lieu
    // du haut-gauche — symétrique par rapport à l'axe horizontal, pas vertical).
    var diagonalRotate = isLeft ? 180 + diagAngle : -diagAngle;
    var horizLeft = isLeft ? -(offX + horizLength) : offX;
    var horizTop = -offY;
    var popupW = (_b = (_a = popupRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 300;
    var popupH = (_d = (_c = popupRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 80;
    var popupLeft = isLeft
        ? -(offX + horizLength + popupW)
        : (offX + horizLength);
    var popupTop = Math.round(-offY - popupH / 2);
    return (_jsx("div", __assign({ className: "labels_handle" }, { children: _jsxs("div", __assign({ id: "label_product", className: "labelAnchor", style: {
                position: 'absolute',
                top: position.y + 'px',
                left: position.x + 'px',
                display: canDisplay ? 'block' : 'none',
            } }, { children: [_jsx("div", { className: "labelLine-diagonalFirst", style: {
                        transform: "rotate(".concat(diagonalRotate, "deg)"),
                        width: "".concat(diagLength, "px"),
                    } }), _jsx("div", { className: "labelLine-horizontal", style: {
                        left: "".concat(horizLeft, "px"),
                        top: "".concat(horizTop, "px"),
                        width: "".concat(horizLength, "px"),
                    } }), _jsx("div", __assign({ ref: popupRef, className: "labelPopup", style: {
                        left: "".concat(popupLeft, "px"),
                        top: "".concat(popupTop, "px"),
                    } }, { children: _jsx("div", __assign({ className: "label-box" }, { children: _jsx("p", __assign({ id: "p_labels", className: "p_labels" }, { children: title })) })) }))] })) })));
}
